export enum PlatformLevel {
    DOMAIN = 'domain',
    ORG = 'org',
}
